import {
  IconWarning20,
  Link,
  Notice,
} from '@lightspeed/unified-components-helios-theme/react'
import React from 'react'
import {
  OutdatedTaxCategoryWarningProps,
  useOutdatedTaxCategoryWarningModel,
} from './useOutdatedTaxCategoryWarningModel'

export const OutdatedTaxCategoryWarning: React.FC<OutdatedTaxCategoryWarningProps> = props => {
  const model = useOutdatedTaxCategoryWarningModel(props)

  if (!model.isOutdated) {
    return null
  }

  return (
    <div data-testid="outdated-tax-category-warning">
      <Notice indicatorSlot={<IconWarning20 />} layout="inline" status="danger">
        <span className="typography-label-sm">
          {model.message}{' '}
          <Link href={model.href} size="inherit">
            {model.linkText}
          </Link>
        </span>
      </Notice>
    </div>
  )
}
